import React, { useEffect, useState } from "react";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

// Helper para formatear fecha como en el ejemplo (01-ago-2026 0:00:00)
const formatoFechaDetalle = (fecha) => {
  if (!fecha) return "";
  try {
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return fecha;
    
    // Formateamos: dd-mmm-yyyy HH:mm:ss
    const fechaPart = d.toLocaleDateString("es-PY", {
      day: "2-digit",
      month: "short", // 'ago', 'ene', etc.
      year: "numeric"
    }).replace(/ /g, "-").replace(".", ""); // Ajuste para guiones

    const horaPart = d.toLocaleTimeString("es-PY", {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });

    return `${fechaPart} ${horaPart}`;
  } catch (e) {
    return fecha;
  }
};

// Helper para moneda
const formatoMonto = (valor) => {
  if (valor === null || valor === undefined) return "";
  return new Intl.NumberFormat("es-PY").format(valor);
};

export default function VerTransaccionesBancard({ id, onClose = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [e, setE] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setErr("");

      try {
        // Asumimos que existe esta ruta para obtener por ID. 
        // Si tu apiRoutes tiene otro nombre (ej: .detail, .get), ajústalo aquí.
        const url = apiRoutes.transaccionBancard.retrieveUrl 
          ? apiRoutes.transaccionBancard.retrieveUrl(id)
          : `/api/transaccionBancard/${id}`; // Fallback por si no tienes la ruta definida

        const data = await appFetchJson(url);

        if (!cancelled) {
          setE(data);
        }
      } catch (error) {
        console.error("Error al cargar Transacción:", error);
        if (!cancelled) {
          setErr("Error al cargar los datos de la transacción.");
          setE(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [id]);

  // Mapeo de campos según el orden solicitado
  const rows = [
    ["Nro.Boleta", e?.numeroComprobante],
    ["Nro. Tarjeta", e?.numeroTarjeta],
    ["Fecha Vencimiento", formatoFechaDetalle(e?.dataVencimiento)],
    ["Nro. Pin Chofer", e?.codigoPinChofer],
    ["Nro. Pin EE.SS.", e?.codigoPinEess],
    ["Cantidad Km", e?.qnCarKm],
    
    ["Cod. Producto 1", e?.codigoProductofixme],
    ["Cant. Prod.1", e?.qnProductofixme],
    ["Precio Producto 1", formatoMonto(e?.valorPrecioProd1)],
    
    ["Cod. Producto 2", e?.codigoProductofixme1],
    ["Cant. Producto 2", e?.qnProductofixme1],
    ["Precio Producto 2", formatoMonto(e?.valorPrecioProd2)],
    
    ["Cod. Comercio", e?.codigoComercio],
    ["Fecha Transaccion", formatoFechaDetalle(e?.dataTransaccion)],
    
    ["Numero de Serie", e?.numeroNumeroSerie],
    ["Nro. Cupon", e?.numeroNumeroCupon],
    ["Nro. de Trama", e?.numeroNumeroTrama],
    
    ["Cod. Error", e?.codigoError],
    ["Cod. Autorizacion", e?.codigoAutorizacion],
    ["Nro. Remito", e?.numeroRemito],
    
    ["Desc. Mensaje", e?.descricaoMensaje],
    ["Desc. Producto 1", e?.descricaoProductofixme],
    ["Desc. Producto 2", e?.descricaoProductofixme1],
    
    ["Monto Transaccion", formatoMonto(e?.valorTransaccion)],
    ["Desc. Tarjeta", e?.descricaoTarjeta],
    ["Desc. Clave de Mensaje", e?.descricaoMsgDsckey], 
    
    ["Mensaje Oracle", e?.descricaoMsgOracle],
    ["Tiempo de Inicio", e?.dataTimeInit],
    ["Tiempo de finalizacion", e?.dataTimeEnd],
    
    ["Nro. Tarjeta Supervisor", e?.numeroTarjetaSuper],
    ["Tipo Transaccion", e?.codigoTipoTransaccion], // Enum name
    ["Mensaje de Estado", e?.descricaoMsgStatus],   // Enum name
    ["Mensaje Nivel", e?.descricaoMsgLevel],       // Enum name
    ["Desc. Mensaje (Key)", e?.descricaoMsgKey],   // Enum name (KeyTransaccionBancardEnum)
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg"> {/* Usamos panel-lg para dar buen ancho */}
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="section-title">Datos de Transacción</h2>
        </div>

        {/* BODY */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">
              Cargando…
            </div>
          )}

          {!loading && err && (
            <div className="py-6 text-center text-red-600">
              {err}
            </div>
          )}

          {!loading && !err && e && (
            <div className="form-grid">
              {rows.map(([label, value], idx) => (
                <Fila key={`${label}-${idx}`} label={label} value={value} />
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value break-words">
        {value !== null && value !== undefined && value !== "" 
          ? value 
          : <span className="text-gray-400">—</span>}
      </div>
    </div>
  );
}